(function() {

  var $self = this;
  $self.ProjectsAndPartnerships          = $self.ProjectsAndPartnerships          || {};
  $self.ProjectsAndPartnerships.projects = $self.ProjectsAndPartnerships.projects || {};

  $self.ProjectsAndPartnerships.projects.search = (function() {
    var pub = {};

    pub.init = function(params) {
      const projectIds = params.projects.map((project) => project.projectId);
      CC.ProjectsAndPartnerships.projects.initiatives.init({
        projectIds,
      });
    };

    return pub;
  })();

}).call(CC);
